<template>
  <div v-loading="loading" class="flex">
    <div class="left">
      <el-tree
        ref="tree"
        :data="treeData"
        show-checkbox
        :check-strictly="true"
        @check-change="selectChange"
        node-key="id"
        :default-expanded-keys="expandedKey"
        :default-checked-keys="selectOrg(orgDatas)"
        :props="defaultProps">
      </el-tree>
    </div>
    <div>
        <el-button
        type="primary"
        size="small"
        @click="showAddList"
      >
        <!--        v-if=" pms['2'].indexOf('test_button_2') != -1 "-->
        确定
      </el-button>
    </div>
  </div>

</template>

<script>
 /* import {queryOrgTree} from "@/api/sys/sys";
  import {queryOrgTreeSelect} from "@/api/sys/sys";*/
/*
  import {queryOrgTree} from "@/api/wage/payGroup";
*/
 import {queryOrgTreeSelect} from "@/api/wage/payGroup";


  import Vue from 'vue'

  export default {
    name: "selectPerson",
    props:{
      orgDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      treeData:[],
      orgTreeDatas:[],
      orgMap:{},
      dialogorgVisible:false,
      vdata:{
        type:String,
        default:'',
      },
      cusId:{
        type:String,
        default:"",
      },
      ifBranch:{
        type:String,
        default:"",
      },
      orgId:{
        type:String,
        default:"",
      },

    },
    created(){
      this._queryOrgTree(this.cusId);
    },
    components:{},
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'orgName',
         
        },
        loading:true,
      expandedKey:[]
      };
    },
    methods:{
      _queryOrgTree(){
        console.log("客户Id------",this.cusId);
        queryOrgTreeSelect(this.cusId).then((res) => {
          this.treeData = res.data;
          this.expandedKey.push(res.data[0].id);
          this.loading = false;
          // console.log('当前CodeItem分页对象为：'+JSON.stringify(this.list))
        }).catch(err=>{
          this.loading=false
        });
      },
      selectOrg(orgDatas){
        var selectArr = [];
        orgDatas.map(function (item) {
          selectArr.push(item.id)
        })
        console.log("点击------",selectArr);
        return selectArr
      },
      selectChange(e1, e2,e3){
        if(e2){

        }else{
          if(this.ifBranch=='10020001' && e1.id == this.orgId){
            this.$message.warning('无法删除该机构')
            this.treeData.push(e1)
            return;
          }
        }


        /*let li = [
          {id:e1.id,orgName:e1.orgName,children:this.children,superId:e1.superId,type:e1.type,orgType:e1.orgType},
        ]
        this.orgDatas = this.orgDatas.concat(li);*/
      },
      showAddList(){
        let list = this.$refs.tree.getCheckedNodes();
        if(list && list.length>0){
          this.dialogorgVisible = false;
          let obj = {org:this.$refs.tree.getCheckedNodes(),dialog:this.dialogorgVisible}
          console.log("确定事件----",obj);
          this.$emit('orgTreeDatas',obj);
        }else{
          this.$message.warning('请选择机构');
        }
      }

    }
  };
</script>

<style scoped>
  .flex>div:nth-of-type(1){
    width: 100%;
    padding-right: 20px;
    margin-right:20px;
    overflow: auto;
    height: 500px;
  }
  .flex>div:nth-of-type(2){
    text-align: center;
  }
</style>
